import type { ReactNode } from 'react';
import { PanelHeader } from '../design-dx/VersionCard';
import { VersionedPdfPane } from '../review-surface/VersionedPdfPane';
import { useApprovalReviewData } from '../approval-review/useApprovalReviewData';

interface OrthoReviewDxReportProps {
    patientId: string;
    addNote: ReactNode;
}

// Final review already published the Dx, so the orthodontist reads the report's PDF versions.
export function OrthoReviewDxReport({ patientId, addNote }: OrthoReviewDxReportProps) {
    const { versions, versionsState, hasMoreVersions, refetch } = useApprovalReviewData(patientId);
    return (
        <div className="flex-1 min-h-0 flex flex-col font-inter">
            <PanelHeader title="Dx report">{addNote}</PanelHeader>
            <div className="flex-1 min-h-0 p-3">
                <VersionedPdfPane
                    patientId={patientId}
                    versions={versions}
                    docLabel="Dx report"
                    versionsState={versionsState}
                    onRetryVersions={refetch}
                    hasMoreVersions={hasMoreVersions}
                />
            </div>
        </div>
    );
}
